<template>
	<div class="panel_shouyin">
		<div class="titleLine">
			<el-row>
				<el-col :span="6">
					
				</el-col>
				<el-col :span="6">
					
				</el-col>
				<el-col :span="2" :offset="22">
					<el-button @click="back" size="mini">返回</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="con">
			<div class="L">
				<!-- <div class="label">经办人</div>
				<el-select v-model="handlerId" @change="changeHandlerId" multiple filterable placeholder="请选择" size="mini" style="width:210px;margin-bottom:20px;">
					<el-option v-for="item in staffList" :key="item._id" :label="item.basic_info.nick_name"
					:value="item._id+','+item.basic_info.nick_name"></el-option>
				</el-select> -->
				<div class="label">支付类型</div>
				<el-radio-group v-model="depositType" @change="changeDepositType" style="width:210px;padding-bottom:20px;padding-top:5px;">
					<el-radio :label="1">押金</el-radio>
					<el-radio :label="2">余额</el-radio>
				</el-radio-group>
				<!-- <div v-if="depositType===1">
					<div class="label">押金金额</div>
					<el-input v-model="deposit" @change="changeDeposit" style="width:210px;padding-bottom:20px;" size="mini" placeholder="请输入金额"></el-input>
					<div class="label">支付方式</div>
					<el-select v-model="payType" @change="changePayType" placeholder="请选择" size="mini" style="width:210px;margin-bottom:20px;">
						<el-option v-for="item in [{value:0,label:'现金'},{value:3,label:'线下支付宝'},{value:4,label:'线下微信'},{value:5,label:'pos'},{value:13,label:'京东聚合'}]" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</div> -->
				<div class="label">自动扣费</div>
				<el-radio-group v-model="autoDeduct"  @change="changeAutoDeduct" disabled style="width:210px;padding-bottom:20px;padding-top:5px;">
					<el-radio :label="true">是</el-radio>
					<el-radio :label="false">否</el-radio>
				</el-radio-group>
			</div>
			<div class="R">
				<div v-for="(petItem,petIndex) in pets_list" :key="petIndex">
					<el-row>
						<el-col :span="6" class="col">
							<div class="RLabel" style="width:100px;">第{{$public.formatNumTochinese(petIndex+1)}}只宠物：</div>
							<el-select v-model="petItem.petId" @change="changePet(petItem.petId,petIndex)" placeholder="请选择" size="mini" style="width:130px;" clearable >
								<el-option v-for="item in userInfo.pets_info||[]" :key="item._id" :label="item.nick_name"
								:value="item._id"></el-option>
							</el-select>
						</el-col>
						<el-col :span="6" class="col">
							<div class="RLabel" style="width:100px;">寄养服务：</div>
							<el-button type="warning" v-if="!petItem.serviceId" size="mini" :disabled="!petItem.petId" @click="openDialogAddService(petIndex)" style="width:130px;">选择寄养服务</el-button>
							<div v-else @click="openDialogAddService(petIndex)">
								{{petItem.serviceItem.title}} {{petItem.skuItem.service_objectName}}
							</div>
						</el-col>
						<el-col :span="6" class="col">
							<div class="RLabel" style="width:100px;">寄养单价：</div>
							<div style="width:130px;color:#FE2D2D;">{{petItem.price}}元 / {{petItem.skuItem?petItem.skuItem.frequency_text:'天'}}</div>
						</el-col>
						<el-col :span="6" class="col">
							<div class="RLabel" style="width:100px;">寄养会员单价：</div>
							<div style="width:130px;color:#FE2D2D;">{{petItem.mprice>0?petItem.mprice:petItem.price}}元 / {{petItem.skuItem?petItem.skuItem.frequency_text:'天'}}</div>
						</el-col>
					</el-row>
					<el-row style="margin: 20px 0;">
						<el-col :span="6" class="col">
							<div class="RLabel" style="width:100px;">开始时间：</div>
							<el-date-picker
								style="width:180px;"
								v-model="petItem.startTime"
								@change="changeStartTime"
								type="datetime"
								placeholder="请选择"
								size="mini"
								:clearable="false">
							</el-date-picker>
						</el-col>
						<el-col :span="6" class="col">
							<div class="RLabel" style="width:100px;">结束时间：</div>
							<el-date-picker
								style="width:180px;"
								v-model="petItem.endTime"
								@change="changeEndTime"
								type="datetime"
								placeholder="请选择"
								size="mini"
								:clearable="false">
							</el-date-picker>
						</el-col>
						<el-col class="col" :span="6">
							<div class="RLabel" style="width:180px;" >寄养房间：<span v-if="petItem.cageInfo.positionId" >{{ petItem.cageInfo.positionName }}{{ petItem.cageInfo.cageName }} </span> </div>
						   <el-button type="warning" @click="addPetCage(petIndex,petItem)" size="mini" style="margin-left:20px;">+选择</el-button>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="col" :span="10">
							<div class="RLabel" style="width:100px;">备注：</div>
							<el-input type="textarea" v-model="petItem.remark" size="mini" style="width:300px;"></el-input>
						</el-col>
					</el-row>
					<div style="margin:20px 0px 40px 30px;height: 1px;background-color: #CECECE;"></div>
				</div>
				<el-button type="warning" @click="addPet" size="mini" style="margin-left:20px;">
					+添加第{{$public.formatNumTochinese(pets_list.length+1)}}只
				</el-button>
			</div>
		</div>
		<div v-if="dialogAddService_state">
			<dialogAddService
			:addShopState="dialogAddService_state"
			:shopId="curShopId" 
			:classType="pets_list[petIndex]?pets_list[petIndex].class_type:'0'" 
			:tree="[{id:'601d11cda93f55b5cf3ae2d1',children:[{id:'601d11cea93f55b5cf3ae2e8'}]}]"
			@closeOn="dialogAddService_state=false"
			@submit="submit_dialogAddService"
			>
			</dialogAddService>
		</div>
		<!-- 赠品 -->
		<div v-if="drawerGift_state">
			<setGift :giveGoods="giveGoods" @submit="submit_drawerGift"></setGift>
		</div>
		<div v-if="petCageState">
        <drawerJiYangPetCage
          :petId="petId"
          :petCage="petCage"
		  :apply_type="apply_type"
          @submit="submit_drawerStatus"
        ></drawerJiYangPetCage>
      </div>
	</div>
</template>
<script>
	import dialogAddService from "../../../../components/dialog_addShop.vue"
	import drawerJiYangPetCage from "../../../../components/drawerPetCage/drawer_JiYangPetCage.vue";
	export default {
		components:{drawerJiYangPetCage,dialogAddService},
		data(){
			return{
				petCage:"",
				// 赠品
				drawerGift_state:false,
				  // 宠物笼子
				petCageState: false,
				giveGoods:{},
				giftTableData:[],
				// 经办人
				handlerId:'',
				staffList:[],
				// 押金
				depositType:1,
				deposit:'',
				payType:0,
				// 自动扣费
				autoDeduct:false,
				// 服务
				dialogAddService_state:false,
				// 房间
				// roomList:[],
				petIndex:-1,
				pets_list:[
					{
						petId:'',
						petItem:'',
						class_type:0,
						serviceId:'',
						serviceItem:null,
						skuId:'',
						skuItem:null,
						activityId:'',
						activityItem:null,
						activityList:[],
						giftTableData:[],
						startTime:new Date(),
						endTime:'',
						roomId:'',
						roomIds:[],
						remark:'',
						price:0,
						activityPrice:0,
						cageInfo:{
							positionId:'',
							positionName:"",
							cageId:'',
							cageName:''
						}
					}
				],
				petId:'',
				// 笼子
				popoverContent:'',
				apply_type:''
				
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
			curPetId(){
				return this.$store.state.mendian.curPetId;
			},
			curPetInfo(){
				return this.$store.getters['mendian/curPetInfo'];
			},
			curShopId(){
				return this.$store.state.shopId;
			},
			addParams(){
				return this.$store.state.jiyang.addParams;
			},
		},
		mounted(){
			this.getStaffList();
			// this.getRoomCageList();
		},
		methods: {
			submit_drawerStatus(obj) {
				this.pets_list[this.petIndex].cageInfo.positionId=obj.positionId;
				this.pets_list[this.petIndex].cageInfo.positionName=obj.positionName
				this.pets_list[this.petIndex].cageInfo.cageId=obj.cageId
				this.pets_list[this.petIndex].cageInfo.cageName=obj.cageName
				// this.pets_list.map((item)=>{
				// 	item.cageInfo.positionId=obj.positionId
				// 	item.cageInfo.positionName=obj.positionName
				// 	item.cageInfo.cageId=obj.cageId
				// 	item.cageInfo.cageName=obj.cageName
				// })
                this.petCageState = false;
           //   this.getTableData();
                },
	      // 选择寄养笼子
			addPetCage(petIndex,petItem){
				console.log(petItem.petId,"this.petItem.petId");
				if(petItem.petId){
					this.apply_type=petItem.petItem.apply_type.value
				console.log(this.apply_type,"22");
				this.petIndex = petIndex;
				this.petCageState = true;
				}else{
					this.$message({
						message: '请选择寄养宠物',
						type: 'error'
					});
				}
				
			},
			// 返回
			back(){
				this.$store.commit('jiyang/set_type','list')
			},
			// 悬浮
			popoverShow(id){
				console.log(id)
			},
			popoverHide(){
				this.popoverContent = ''
			},
			// 经办人
			changeHandlerId(){
				this.addParams.handlerId = this.handlerId
				this.$store.commit('jiyang/set_addParams',this.addParams)
			},
			// 支付类型
			changeDepositType(){
				if(this.depositType===1){
					this.autoDeduct = false
					for(let i=0;i<this.pets_list.length;i++){
						this.pets_list[i].activityId=''
						this.pets_list[i].activityItem=null
						this.pets_list[i].giftTableData=[]
						this.pets_list[i].activityPrice=this.pets_list[i].price
					}
				}else{
					this.autoDeduct = false
					this.deposit = ''
					this.addParams.deposit = this.deposit
				}
				this.addParams.autoDeduct = this.autoDeduct
				this.$store.commit('jiyang/set_addParams',this.addParams)
				this.addParams.depositType = this.depositType
				this.$store.commit('jiyang/set_addParams',this.addParams)
			},
			// 押金金额
			changeDeposit(){
				this.addParams.deposit = this.deposit
				this.$store.commit('jiyang/set_addParams',this.addParams)
			},
			// 支付方式
			changePayType(){
				this.addParams.payType = this.payType
				this.$store.commit('jiyang/set_addParams',this.addParams)
			},
			// 是否自动扣费
			changeAutoDeduct(){
				this.addParams.autoDeduct = this.autoDeduct
				this.$store.commit('jiyang/set_addParams',this.addParams)
			},
			// 备注
			changeRemark(){
				this.addParams.remark = this.remark
				this.$store.commit('jiyang/set_addParams',this.addParams)
			},
			// 改变宠物
			changePet(petId,petIndex){
				console.log(petId,"petId = petId");
				this.petId=petId
				console.log(this.petId,"this.petid");
				let petItem = this.$public.getMatchingItem(this.userInfo.pets_info,'_id',petId);
				if(petItem.weight<=0){
					this.$message({
						message: '该宠物没有设置体重，请先设置宠物体重',
						type: 'error'
					});
					this.pets_list[petIndex].petId = ''
					return ;
				}
				console.log(this.pets_list[petIndex],"this.pets_list[petIndex]");
				this.pets_list[petIndex].petId = petId;
				this.pets_list[petIndex].petItem = petItem;
				this.pets_list[petIndex].class_type = petItem.class_type;
				this.pets_list[petIndex].serviceId = '';
				this.pets_list[petIndex].serviceItem = null;
				this.pets_list[petIndex].skuId = '';
				this.pets_list[petIndex].skuItem = null;
				this.pets_list[petIndex].activityId = '';
				this.pets_list[petIndex].activityItem = null;
				this.pets_list[petIndex].activityList = [];
				this.pets_list[petIndex].giftTableData = [];
				this.pets_list[petIndex].price = 0;
				this.pets_list[petIndex].mprice = 0;
				this.pets_list[petIndex].activityPrice = 0;
				this.pets_list[petIndex].roomIds = [];
				this.pets_list[petIndex].cageInfo.positionId = '';
				this.pets_list[petIndex].cageInfo.positionName = '';
				this.pets_list[petIndex].cageInfo.cageId = '';
				this.pets_list[petIndex].cageInfo.cageName = '';
				this.addParams.pets_list = this.pets_list;
				this.$store.commit('jiyang/set_addParams',this.addParams)
			},
			// 改变时间
			changeStartTime(){
				this.addParams.pets_list = this.pets_list
				this.$store.commit('jiyang/set_addParams',this.addParams)
			},
			changeEndTime(){
				this.addParams.pets_list = this.pets_list
				this.$store.commit('jiyang/set_addParams',this.addParams)
			},
			///////////////////////////////////        服务
			openDialogAddService(petIndex){
				this.petIndex = petIndex;
				this.dialogAddService_state = true;
			},
			submit_dialogAddService(obj){
			  console.log(obj,'ob寄养');
				this.pets_list[this.petIndex].serviceId = obj.goodsItem.serviceId;
				this.pets_list[this.petIndex].serviceItem = obj.goodsItem;
				this.pets_list[this.petIndex].skuId = obj.skuItem.service_objectId;
				this.pets_list[this.petIndex].skuItem = obj.skuItem;
				this.pets_list[this.petIndex].price = obj.skuItem.price;
				this.pets_list[this.petIndex].mprice = obj.skuItem.mprice;
				this.pets_list[this.petIndex].activityPrice = obj.skuItem.price;
				// this.addParams.pets_list = this.pets_list
				// this.$store.commit('jiyang/set_addParams',this.addParams)
				this.dialogAddService_state = false;
				// this.getActivityList()
			},
			// ///////////////////////////////////////       活动
			changeActivityId(activityId,petIndex){
				this.pets_list[petIndex].activityId = activityId;
				this.pets_list[petIndex].activityItem = this.$public.getMatchingItem(this.pets_list[petIndex].activityList,"_id",activityId);
				if(this.$public.isNull(activityId)){
					this.pets_list[petIndex].activityPrice = this.pets_list[petIndex].price;
				}else{
					let calcResult=this.$public.calcActivity(this.pets_list[petIndex].activityItem,this.pets_list[petIndex].price,1)
					console.log(calcResult)
					this.pets_list[petIndex].activityPrice = calcResult.newPrice;
					if(!this.$public.isNull(calcResult.gift.give_list)){
						this.giveGoods = calcResult.gift;
						this.drawerGift_state = true;
					}
				}
				this.addParams.pets_list = this.pets_list;
				this.$store.commit('jiyang/set_addParams',this.addParams)
			},
			getActivityList(){
				let item = this.pets_list[this.petIndex]
				if(!item.serviceItem.serviceId){
					return ;
				}else{
					let arr = [{
						"goodsId": item.serviceItem.serviceId,
						"skus": item.skuItem.service_objectId,
						"skuValue": item.serviceItem.title+' '+item.skuItem.service_objectName,
						"brand": '', // 品牌id 只有商品接收此字段
						"categoryId": item.serviceItem.category_info._id,  // 分类id
						unitId:'',
						customCode:'',
					}]
					this.$util.getActivityOfProduct(this.userInfo,arr).then(res=>{
						for(let i=0;i<arr.length;i++){
							item.activityList=res[i].list;
							if(!this.$public.isNull(res[i].list)&&res[i].list[0].auto_matching>0){
								if(this.$public.isNull(item.activityId)){
									if(this.depositType!==1){
										if(this.$public.isNull(this.curDiscountCard&&this.curDiscountCard._no)){
											item.activityId = res[i].list[0]._id;
											item.activityItem = res[i].list[0];
											let calcResult=this.$public.calcActivity(item.activityItem,this.$public.cheng(item.price,1),1)
											console.log(calcResult,'/////////')
											item.activityPrice = this.$public.chu(calcResult.newPrice,1);
											if(!this.$public.isNull(calcResult.gift.give_list)){
												this.giveGoods = calcResult.gift;
												this.drawerGift_state = true;
											}
										}
									}
								}
							}
							this.$set(this.pets_list,this.petIndex,item)
						}
						this.addParams.pets_list = this.pets_list
						this.$store.commit('jiyang/set_addParams',this.addParams)
					})
				}
			},
			// 赠品
			openGift(petIndex){
				this.petIndex = petIndex;
				this.giveGoods.giftTableData = JSON.parse(JSON.stringify(this.pets_list[petIndex].giftTableData))
				this.drawerGift_state=true
			},
			submit_drawerGift({giftTableData}){
				this.drawerGift_state = false;
				this.pets_list[this.petIndex].giftTableData = giftTableData;
				this.addParams.pets_list = this.pets_list
				this.$store.commit('ximei/set_addParams',this.addParams)
			},
			// 笼子
			isCanUse(item,petIndex){
				let curPet = this.pets_list[petIndex].petItem||{}
				if(
					(item.pet_list.length>0&&curPet.class_type===Number(item.pet_list[0].pet_type.value))
					||item.pet_list.length===0
					||!curPet._id
				){
					return true;
				}else{
					return false;
				}
			},
			// 添加宠物
			addPet(){
				let a = {
					petId:'',
					petItem:null,
					class_type:0,
					serviceId:'',
					serviceItem:null,
					skuId:'',
					skuItem:null,
					activityId:'',
					activityItem:null,
					activityList:[],
					giftTableData:[],
					startTime:new Date(),
					endTime:null,
					roomIds:[],
					remark:'',
					price:0,
					activityPrice:0,
					cageInfo:{
						    positionId:'',
							positionName:"",
							cageId:'',
							cageName:''
					}
				}
				this.pets_list.push(a);
			},
			
			// 获取销售人员列表
			getStaffList() {
				let params = {
					"keyword": '',
					"pageIndex": 1,
					"pageSize": 500,
				}
				this.$http.get('/api/Staff/List', params).then(res => {
					if (res.code == 0) {
						this.staffList = res.data.data;
					}
				})
			},
		}
	}
</script>
<style scoped lang="scss">
.panel_shouyin{
	height: 100%;
	padding-bottom: 60px;
	box-sizing: border-box;
	position: relative;
	.titleLine{
		width:100%;
		background-color: #fff;
		height: 44px;
		padding:8px 8px;
		box-sizing: border-box;
		margin-bottom: 4px;
		position: absolute;
		z-index: 1;
	}
	.con{
		display: flex;padding:30px 10px 100px 20px;background-color: #fff;width:100%;height: 100%;box-sizing: border-box;padding-top:50px;position: absolute;top:0;
		.L{
			width:248px;border-right: 1px solid #f5f5f5;flex-shrink: 0;box-sizing: border-box;
			.label{
				font-size: 14px;padding-bottom:10px;
			}
		}
		.R{
			width:100%;height: 100%;overflow: auto;
			&::-webkit-scrollbar {
				width: 4px;
				// height: 4px;
			}
			.col{
				display: flex;
				align-items: center;
				padding-bottom:15px;
				.RLabel{
					font-size: 14px;
					color:$fontColor;
					text-align: right;
					line-height: 28px;
				}
			}
			.roomBox{
				display: flex;padding:10px 30px;flex-wrap: wrap;
				.room{
					position: relative;width:110px;height: 40px;border-radius: 2px;border:1px solid #C0C4CC;box-sizing: border-box;background-color: #E8E8E8;margin:4px 6px;text-align: center;cursor: pointer;
					.mask{
						position: absolute;top:-2px;left:-2px;z-index: 10;width:110px;height: 40px;background-color: rgba(0,0,0,.5);
					}
					.tip{
						position: absolute;top:-2px;left:-2px;width:55px;height: 20px;text-align: center;color:#fff;background-color: #FFAE11;font-size: 12px;line-height: 20px;
					}
					.checked{
						position: absolute;right:0;bottom:0;width:26px;height: 13px;text-align: center;color:#fff;
					}
					.roomName{
						font-size: 12px;color:#262626;padding-top:5px;
					}
					.roomPrice{
						font-size: 12px;color:#262626;padding-top:5px;
					}
					&.active{
						background-color: #FFEAC2;border-color:#FFAE11;
					}
				}
			}
		}
	}
}
</style>
